import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6fd2baf3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Teacher" }
const _hoisted_2 = { class: "teacher-other" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon-upload" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("将图片拖到此处，或"),
  /*#__PURE__*/_createElementVNode("em", null, "点击上传")
], -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "支持 jpg,png 格式，不超过20m", -1))

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { modalConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModal } from '@/hooks/usePageModal'
import { initEmptyParam } from '@/hooks/useInitParam'
import { reactive, ref } from 'vue'
import { useUpload } from '@/hooks/useUpload'
import { ElMessage } from 'element-plus'


export default /*#__PURE__*/_defineComponent({
  __name: 'Teacher',
  setup(__props) {

initEmptyParam()
const modalTitle = ref('新增')
const otherInfo = reactive({
  cover: ''
})

const [uploadRef, extraData, files, action, beforeUpload, proveUpload, onSuccess, onExceed] =
  useUpload()
const fileList = ref<any[]>([])

const newCb = () => {
  modalTitle.value = '新增老师'
  otherInfo.cover = ''
  fileList.value = []

  files.value = []
}

const editCb = (item: any) => {
  modalTitle.value = '编辑老师'
  otherInfo.cover = item.cover
  files.value.push(item.cover)

  fileList.value = [
    {
      name: 'cover' + item.cover.substring(item.cover.lastIndexOf('.')),
      url: item.cover
    }
  ]
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal(
  newCb,
  editCb
)
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch()

const handleValid = () => {
  if (files.value.length > 0) {
    otherInfo.cover = files.value[0]
    return true
  }

  ElMessage.error({ type: 'error', message: '请先上传图片' })

  return false
}

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_PageModal = _resolveComponent("PageModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "fuboTeacher",
      deleteTip: "确认删除此老师吗？",
      onNewBtnClick: _unref(handleNewData),
      onEditBtnClick: _unref(handleEditData)
    }, {
      cover: _withCtx((scope) => [
        _createVNode(_component_el_image, {
          style: {"width":"80px","height":"100px"},
          src: scope.row.cover,
          fit: "fill"
        }, null, 8, ["src"])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onNewBtnClick", "onEditBtnClick"]),
    _createVNode(_component_PageModal, {
      ref_key: "pageModalRef",
      ref: pageModalRef,
      defaultInfo: _unref(defaultInfo),
      modalConfig: _unref(modalConfig),
      title: modalTitle.value,
      pageName: "fuboTeacher",
      otherInfo: otherInfo,
      validOtherInfo: handleValid
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_upload, {
            ref_key: "uploadRef",
            ref: uploadRef,
            drag: "",
            "auto-upload": true,
            action: _unref(action),
            data: _unref(extraData),
            "file-list": fileList.value,
            "before-upload": _unref(beforeUpload),
            "list-type": "picture",
            accept: ".jpg, .jpeg, .png",
            "on-success": _unref(onSuccess),
            "on-exceed": _unref(onExceed),
            limit: 1
          }, {
            tip: _withCtx(() => [
              _hoisted_5
            ]),
            default: _withCtx(() => [
              _hoisted_3,
              _hoisted_4
            ]),
            _: 1
          }, 8, ["action", "data", "file-list", "before-upload", "on-success", "on-exceed"])
        ])
      ]),
      _: 1
    }, 8, ["defaultInfo", "modalConfig", "title", "otherInfo"])
  ]))
}
}

})